module.exports = __webpack_public_path__ + "static/media/MartinTriste.243cb2de.svg";